// extracted by mini-css-extract-plugin
export default {"iconlink":"IconLink_iconlink__itcfM"};